import React from "react";
import {
  CountPlotImg,
  CountPlotBySexImg,
  DeathRatingLeadingCauseImg,
  DeathRatingLeadingCauseByEthnicityImg
} from "../components/styles/CountPlot.styled";
import { Text, Divider } from "../styles/General.styled";

const CountPlot = () => {
  return (
    <>
      <CountPlotImg />
      <Text m="-0.5rem 4.5rem 0 4.5rem">
        This count plot display the count of death recorded by various reasons.
        Malignant Neoplams, Diseases of Heart, Cerebrovasucular Disease, and
        Influenza tops the list at 64 occurrences each.
      </Text>
      <Divider />
      <CountPlotBySexImg />
      <Text m="-0.5rem 4.5rem 0 4.5rem">
        Similar to the first plot, but this time the data is further broken down
        by sex. It is apparent that for the top leading causes, the amount of
        death recorded for both men and women are nearly identical. This plot
        indicates that these leading causes of death does not pick their target
        by sex.
      </Text>
      <Divider />
      <DeathRatingLeadingCauseImg />
      <Text m="-0.5rem 4.5rem 0 4.5rem">
        This bar plot shows the leading causes of death and their death rates.
        Diseases of Heart is on top of the list, suggesting that the there could
        be something wrong with many NYC citizen's life style that leads to the
        failure of the heart functioning properly.
      </Text>
      <Divider />
      <DeathRatingLeadingCauseByEthnicityImg />
      <Text m="-0.5rem 4.5rem 0 4.5rem">
        This bar plot shows the leading causes of death along with their death
        rate further separated by race ethnicity. It is apparent that Black
        Non-Hispanic and white non-hispanic has the highest death rates amongst
        all race ethnicities, with the latter topping out. The distribution
        between "Malignant Neoplasms" and "Diseases of Heart" is actually quite
        similar, leading to the hypothesis that there could be sort of
        correlation between these 2 death causes.
      </Text>
      <Divider />
    </>
  );
};

export default CountPlot;
